import { Select, type ISelectProps } from '@procurify/ui'
import { useIntl } from 'react-intl'

import { countryOptions, type CountryOption } from './countryOptions'
import messages from './messages'

export const CountrySelect = (props: ISelectProps<CountryOption>) => {
  const intl = useIntl()

  return (
    <Select<CountryOption>
      options={countryOptions}
      getOptionLabel={(opt) => opt.name}
      getOptionValue={(opt) => opt.code}
      placeholder={intl.formatMessage(messages.selectPlaceholderText)}
      {...props}
    />
  )
}

CountrySelect.displayName = 'CountrySelect'
